import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * One card surface with a titled header — the single repeated container for
 * every analytics block (timing, outcome, attendance, recording), so the whole
 * view keeps one spacing rhythm and one border/shadow language.
 */
export function Section({
  title,
  icon,
  aside,
  bodyClassName,
  children,
}: {
  title: string;
  icon?: React.ReactNode;
  aside?: React.ReactNode;
  bodyClassName?: string;
  children: React.ReactNode;
}) {
  return (
    <section className="overflow-hidden rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--surface)] shadow-[var(--shadow-sm)]">
      <div className="flex items-center justify-between gap-3 border-b border-[var(--border)] px-5 py-3.5">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-[var(--text-primary)]">
          {icon && <span className="text-[var(--text-muted)]">{icon}</span>}
          <span>{title}</span>
        </h2>
        {aside}
      </div>
      <div className={cn('p-5', bodyClassName)}>{children}</div>
    </section>
  );
}
